/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import isArray from 'lodash/isArray';
import range from 'lodash/range';
import cx from 'classnames';

const propTypes = {
  data: PropTypes.array.isRequired,
  pageSize: PropTypes.number,
  pageLinksSize: PropTypes.number,
  rowKeyAttr: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  WrapperComponent: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]).isRequired,
  RowItemComponent: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]).isRequired,
};

const defaultProps = {
  pageSize: 20,
  pageLinksSize: 6,
  rowKeyAttr: 'id',
};

class PaginateButton extends Component {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.changeCurrentPage(this.props.page);
  }

  render() {
    const { page, className, disabled } = this.props;
    return (
      <button
        type="button"
        className={className}
        disabled={disabled}
        onClick={this.onClick}
      >
        {page}
      </button>
    );
  }
}

PaginateButton.propTypes = {
  changeCurrentPage: PropTypes.func,
  page: PropTypes.number,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

class Paginate extends Component {
  constructor() {
    super();
    this.state = {
      currentPage: 1,
    };
    this.changeCurrentPage = this.changeCurrentPage.bind(this);
    this.onPrevBtnClick = this.onPrevBtnClick.bind(this);
    this.onNextBtnClick = this.onNextBtnClick.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { data } = this.props;
    if (data.length !== nextProps.data.length || !isEqual(data, nextProps.data)) {
      this.changeCurrentPage(1);
    }
  }

  onNextBtnClick() {
    this.changeCurrentPage(this.state.currentPage + 1);
  }

  onPrevBtnClick() {
    this.changeCurrentPage(this.state.currentPage - 1);
  }

  getRowKey(row) {
    const { rowKeyAttr } = this.props;
    if (isArray(rowKeyAttr)) {
      const key = rowKeyAttr.reduce((previousValue, currentValue) => {
        if (row[previousValue]) {
          return `${row[previousValue]}_${row[currentValue]}`;
        }
        return `${previousValue}_${row[currentValue]}`;
      });
      return key;
    }
    return row[rowKeyAttr];
  }

  getRange(current, total, itemsToDisplay) {
    if (total <= itemsToDisplay) {
      return range(1, total + 1);
    }

    let startPage;
    let endPage;

    const middle = Math.floor(itemsToDisplay / 2);

    if (current <= middle) {
      startPage = 1;
      endPage = itemsToDisplay;
    } else if (current + middle - 1 >= total) {
      startPage = total - itemsToDisplay + 1;
      endPage = total;
    } else {
      const correction = (itemsToDisplay % 2 === 0) ? 1 : 0;
      startPage = current - middle;
      endPage = current + middle - correction;
    }

    return range(startPage, endPage + 1);
  }

  changeCurrentPage(index) {
    this.setState({
      currentPage: index,
    });
    const viewportOffset = this.paginate.getBoundingClientRect();
    if (viewportOffset.top < 0) {
      this.paginate.scrollIntoView();
    }
  }

  render() {
    const {
      WrapperComponent, RowItemComponent, data, pageSize, pageLinksSize,
    } = this.props;
    const { currentPage } = this.state;

    const isPaginated = data.length > pageSize;

    let rows = [];
    let pages = 0;
    let total = 0;

    if (isPaginated) {
      rows = data.slice((currentPage - 1) * pageSize, currentPage * pageSize);
      total = Math.ceil(data.length / pageSize);
      pages = this.getRange(currentPage, total, pageLinksSize);
    } else {
      rows = data;
    }

    return (
      <div className="paginate" ref={(paginate) => { this.paginate = paginate; }}>
        <WrapperComponent>
          {rows.map((row) => <RowItemComponent key={this.getRowKey(row)} data={row} />)}
        </WrapperComponent>
        {isPaginated
          && (
          <nav className="paginate__nav">
            <button
              type="button"
              className="paginate__nav-btn paginate__nav-btn--prev"
              disabled={currentPage === 1}
              onClick={this.onPrevBtnClick}
            />
            {pages.map((page) => {
              const btnClasses = cx({
                'paginate__nav-btn': true,
                'paginate__nav-btn--current': currentPage === page,
              });
              return (
                <PaginateButton
                  key={page}
                  page={page}
                  className={btnClasses}
                  disabled={currentPage === page}
                  changeCurrentPage={this.changeCurrentPage}
                />
              );
            })}
            <button
              type="button"
              className="paginate__nav-btn paginate__nav-btn--next"
              disabled={currentPage === total}
              onClick={this.onNextBtnClick}
            />

          </nav>
          )}
      </div>
    );
  }
}

Paginate.propTypes = propTypes;
Paginate.defaultProps = defaultProps;

export default Paginate;
